<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
    :showFooter="false"
    :hasInstructions="false"
  >
    <v-card max-width="800" class="mx-auto pt-4" flat>
      <v-container>
        <v-row>
          <thg-impact-factor-slider
            class="pr-4 pl-4"
            v-if="showImpactSlider"
            :impactTypeItem="icon"
            :sliderValue="sliderValue"
          />
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-card v-if="sliderValue != 0" class="mx-auto mb-5" max-width="500">
              <v-img
                class="white--text"
                height="130"
                :src="item.src"
                gradient="to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)"
              >
                <v-card-title
                  >{{ cashImpactInvestment }} % {{ $t(item.title, { company: company }) }}
                  {{ isRetried ? "" : "*" }}</v-card-title
                >
                <v-card-subtitle class="pb-0">
                  {{ $t(item.subtitle) }}
                </v-card-subtitle>
              </v-img>
            </v-card>
            <v-card v-if="sliderValue != 100" class="mx-auto mb-5" max-width="500">
              <v-img
                class="white--text"
                height="130"
                :src="itemPayout.src"
                gradient="to top right, rgba(30, 30, 30, 0.58), rgba(30, 30, 30, 0.58)"
              >
                <v-card-title>{{ cashPayment }} % {{ $t("report.thgImpactTypeItems.payoutTitle") }}*</v-card-title>
                <v-card-subtitle class="pb-0">
                  {{ $t(itemPayout.subtitle) }}
                </v-card-subtitle>
              </v-img>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-subheader v-if="isRetried"></v-subheader>
    <v-subheader v-else-if="!isWhiteLabelPartner" class="mb-4"
      ><small v-html="$t('report.thgImpactFactor.note')"></small>
    </v-subheader>
    <v-subheader v-else class="mb-4"
      ><small v-html="$t('report.thgImpactFactor.noteWhiteLabelPartner')"></small>
    </v-subheader>
  </layout-report-step>
</template>

<script lang="ts">
import ThgImpactFactorSlider from "@/components/thg/ThgImpactFactorSlider.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { PartnerModule } from "@/store/modules/partner";
import { ReportModule } from "@/store/modules/report.store";
import { ThgCreateModule } from "@/store/modules/thg.create.store";
import { Component } from "vue-property-decorator";
import { ImpactTypeEnum } from "../../views/thg/enum/impact-type.enum";

@Component({
  components: {
    LayoutReportStep,
    ThgImpactFactorSlider
  }
})
export default class ThgImpactFactor extends ReportStepMixin implements IReportStep {
  header: IReportHeaderData = {
    title: "report.thgImpactFactor.title",
    description: ThgCreateModule.impactTypeItem.description
  };

  screen = ReportScreenEnum.thgimpactfactor;

  get isWhiteLabelPartner(): boolean {
    return PartnerModule?.partner.partnerType === PartnerTypeEnum.THG_WHITE_LABEL_QUOTE_AS_A_SERVICE;
  }

  get sliderValue(): number {
    return ThgCreateModule.impactFactor;
  }

  get company() {
    return ReportModule.partner.companyName;
  }

  get icon(): string {
    return ThgCreateModule.impactTypeItem.icon;
  }

  get impactType(): ImpactTypeEnum {
    return ThgCreateModule.impactType;
  }

  get showImpactSlider(): boolean {
    return ThgCreateModule.impactTypeItem.showImpactFactorSlider;
  }

  get showImpactFactorSlider(): boolean {
    return ThgCreateModule.impactTypeItem.showImpactFactorSlider;
  }

  get cashImpactInvestment() {
    return this.sliderValue;
  }

  get cashPayment() {
    return 100 - this.sliderValue;
  }

  get item() {
    return ThgCreateModule.impactTypeItem;
  }

  get itemPayout() {
    return ThgCreateModule.itemPayout;
  }

  get isDone() {
    return true;
  }

  get color() {
    return getDefaultPartnerColor();
  }

  get isRetried() {
    return this.item.impactType === ImpactTypeEnum.retire;
  }

  updateImpactFactor() {
    ThgCreateModule.setImpactFactor(this.sliderValue);
  }

  disablePastDates(val: string) {
    return val >= new Date().toISOString().substr(0, 10);
  }
}
</script>

<style scoped>
.center {
  text-align: center;
}
</style>
